import LoadingState from '@/api/LoadingState';

/**
 * @typedef {Object} ExerciseDocuments
 * @property {String} exerciseId
 * @property {Array<ExerciseDocument>} exerciseDocuments
 */

/**
 * @typedef {Object} ExerciseDocument
 * @property {String} documentName
 * @property {String} documentUrl
 */

const state = {
  exerciseDocuments: [],
  loadingState: {
    documents: LoadingState.INITIAL,
    names: LoadingState.INITIAL
  }
}

export default state
